import { useMatches } from "@remix-run/react";
import { useEffect } from "react";
import log from "../logging/log";
import { isSessionSampled, type SamplingStorage } from "./isSessionSampled";
import { hasSessionReplay } from "./sessionReplayHandle";
import { startSessionReplay } from "./sessionReplayRecorder";

const SESSION_REPLAY_SAMPLE_RATE = 0.1;

const inMemoryStorage = new Map<string, string>();

const samplingStorage: SamplingStorage = {
  getItem: (key) => {
    try {
      return (
        window.sessionStorage.getItem(key) ?? inMemoryStorage.get(key) ?? null
      );
    } catch {
      return inMemoryStorage.get(key) ?? null;
    }
  },
  setItem: (key, value) => {
    inMemoryStorage.set(key, value);

    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {
      log.warn("Could not persist session replay sampling", error);
    }
  },
};

export function useSessionReplay() {
  const isReplayRoute = useMatches().some((match) =>
    hasSessionReplay(match.handle),
  );

  useEffect(() => {
    if (
      isReplayRoute &&
      isSessionSampled({
        storage: samplingStorage,
        sampleRate: SESSION_REPLAY_SAMPLE_RATE,
      })
    ) {
      startSessionReplay();
    }
  }, [isReplayRoute]);
}
